import { render, staticRenderFns } from "./addRedemptionCode.vue?vue&type=template&id=5d13e774&scoped=true&"
import script from "./addRedemptionCode.vue?vue&type=script&lang=js&"
export * from "./addRedemptionCode.vue?vue&type=script&lang=js&"
import style0 from "./addRedemptionCode.vue?vue&type=style&index=0&id=5d13e774&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d13e774",
  null
  
)

export default component.exports